var map = {
	"./v1/EtherRouter.json": 1301,
	"./v1/IColony.json": 1302,
	"./v1/IColonyNetwork.json": 1303,
	"./v1/IMetaColony.json": 1304,
	"./v1/IRecovery.json": 1305,
	"./v1/ITokenLocking.json": 1306,
	"./v1/OldRoles.json": 1307,
	"./v1/OldRolesFactory.json": 1308,
	"./v1/OneTxPayment.json": 1309,
	"./v1/OneTxPaymentFactory.json": 1310,
	"./v1/Token.json": 1311,
	"./v1/TokenAuthority.json": 1312,
	"./v2/EtherRouter.json": 1313,
	"./v2/IColony.json": 1314,
	"./v2/IColonyNetwork.json": 1315,
	"./v2/IMetaColony.json": 1316,
	"./v2/IRecovery.json": 1317,
	"./v2/ITokenLocking.json": 1318,
	"./v2/OldRoles.json": 1319,
	"./v2/OldRolesFactory.json": 1320,
	"./v2/OneTxPayment.json": 1321,
	"./v2/OneTxPaymentFactory.json": 1322,
	"./v2/Token.json": 1323,
	"./v2/TokenAuthority.json": 1324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;